import { axiosPrivate } from "@app/dashboard/tools/axios/axiosInstance"

export const getMerchantClass = () => {
    return axiosPrivate.get(`/dashboard/api/v1/change_merchant_class/merchant_class`)
}

export const changeInstantSet = (isSubscribeAction: boolean) => {
    return axiosPrivate.post(`/dashboard/api/v1/change_merchant_class`, {})
}
